/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZerogValidatorAddressSummaryInfo } from './ZerogValidatorAddressSummaryInfo';

export type ZerogDelegatorValidatorInfo = {
    VD: ZerogValidatorAddressSummaryInfo;
    VSTAT: ZerogDelegatorValidatorInfo.VSTAT;
    DS: string;
    TKN: string;
    TKNVAL: string;
    CMS: string;
    APY: string;
    AG: string;
    UT: number;
};

export namespace ZerogDelegatorValidatorInfo {

    export enum VSTAT {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }


}

